<div id="gotoTop" class="icon-angle-up back-to-top" (click)="goToTop()" (keyup.enter)="goToTop()" (scroll)="scroll()" [hidden]="backToTop" tabindex="0"></div>